import React, { createContext, useState, useContext } from "react";
import { ToastContainer } from "react-toastify";
import axios from "axios";

import AccountDetails from "./components/AccountDetails";
import { toastSuccess, toastError } from "../../shared/toastHelper";

const AccountDetailsContext = createContext();

export function useAccountDetailsContext() {
  return useContext(AccountDetailsContext);
}

const AccountDetailsProvider = (props) => {
  const { csrfToken, businessTypes, stripePublishableKey } = props;

  const [team, setTeam] = useState(props.team);
  const [saving, setSaving] = useState(false);
  const [errors, setErrors] = useState([]);

  const updateTeam = async (updates) => {
    setSaving(true);
    setErrors([]);

    axios.defaults.headers.common["X-CSRF-TOKEN"] = csrfToken;

    try {
      const response = await axios.patch(`/teams/${team.id}/update_account_details`, {
        team: updates
      });

      const updatedTeam = response.data.team;
      setTeam(updatedTeam);
      return updatedTeam;
    } catch (error) {
      const errorMessages = error.response?.data?.errors || ["Failed to save account details"];
      setErrors(errorMessages);
      toastError(errorMessages.join(", "));
      return false;
    } finally {
      setSaving(false);
    }
  };

  const value = {
    team,
    setTeam,
    saving,
    errors,
    updateTeam,
    csrfToken,
    businessTypes,
    stripePublishableKey,
  };

  return (
    <AccountDetailsContext.Provider value={value}>
      {props.children}
    </AccountDetailsContext.Provider>
  );
};

const AccountDetailsContainer = (props) => (
  <AccountDetailsProvider {...props}>
    <ToastContainer icon={false} />
    <AccountDetails />
  </AccountDetailsProvider>
);

export default AccountDetailsContainer;
export { AccountDetailsProvider };
